import { Routes, Route, Navigate } from 'react-router-dom';
import UsersPage from './pages/UsersPage';
import UnmatchedPage from './pages/UnmatchedPage';
import PromosPage from './pages/PromosPage';
import FeatureBoardPage from './pages/FeatureBoardPage';
import FeedbackPage from './pages/FeedbackPage';
import StatisticsPage from './pages/StatisticsPage';
import TrialConversionPage from './pages/TrialConversionPage';
import Layout from './components/Layout';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/users" replace />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/unmatched" element={<UnmatchedPage />} />
        <Route path="/promos" element={<PromosPage />} />
        <Route path="/feature-board" element={<FeatureBoardPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/statistics" element={<StatisticsPage />} />
        <Route path="/trial-conversion" element={<TrialConversionPage />} />
        <Route path="/ai-usage" element={<Navigate to="/statistics" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/users" replace />} />
    </Routes>
  );
}

export default App;
